import { shareAxios } from './config'

/**
 * 用户登录
 * @param {Object} params - 登录参数
 * @param {string} params.userToken - 用户令牌
 * @param {string} params.password - 密码
 * @param {string} params.token - token
 * @returns {Promise}
 */
export const login = (params) => {
  return shareAxios.post('/frontend-api/login', {
    userToken: params.userToken || '',
    password: params.password || '',
    token: params.token || ''
  })
}

/**
 * 发送注册验证码邮件
 * @param {Object} params - 参数
 * @param {string} params.email - 邮箱地址
 * @returns {Promise}
 */
export const sendRegisterEmail = (params) => {
  return shareAxios.post('/frontend-api/sendOpMail', {
    email: params.email,
    actions: 'register'
  })
}

/**
 * 用户注册
 * @param {Object} params - 注册参数
 * @param {string} params.username - 用户名
 * @param {string} params.email - 邮箱
 * @param {string} params.password - 密码
 * @param {string} params.code - 验证码
 * @returns {Promise}
 */
export const register = (params) => {
  return shareAxios.post('/frontend-api/register', {
    userToken: params.userToken,
    password: params.password,
    email: params.email,
    emailCode: params.emailCode,
    inviterId: params.inviterId || '',
    token: params.token || ''
  })
}

/**
 * 发送重置密码邮件
 * @param {Object} params - 参数
 * @param {string} params.email - 邮箱
 * @returns {Promise}
 */
export const sendResetPasswordEmail = (params) => {
  return shareAxios.post('/frontend-api/sendOpMail', {
    email: params.email,
    actions: 'reset'
  })
}

/**
 * 重置密码接口
 * @param {Object} params - 重置密码参数
 * @param {string} params.email - 邮箱
 * @param {string} params.emailCode - 验证码
 * @param {string} params.password - 新密码
 * @returns {Promise}
 */
export const resetPassword = (params) => {
  return shareAxios.post('/frontend-api/resetPwd', {
    email: params.email,
    emailCode: params.emailCode,
    password: params.password
  })
}

/**
 * 点击车对卡片登录会话
 * @param {Object} params - 参数
 * @param {string} params.carid - 车队ID
 * @param {string} params.carType - 车型类型 (chatgpt/grok)
 * @returns {Promise}
 */
export const loginSession = (params) => {
  return shareAxios.get('/auth/loginSession', {
    params: {
      carid: params.carid,
      carType: params.carType
    }
  })
}

